/**
 * @file Unbounce related constants.
 */

/**
 * A hardcoded id:join_code map of Album Folders
 * that should be redirected to Unbounce for A/B testing.
 *
 * TODO This should be turned into a Gallery setting
 * if upgraded from experiment status.
 *
 * @enum ALBUM_FOLDER_UB_REDIRECTS
 */
const ALBUM_FOLDER_UB_REDIRECTS = {
  // DEV Album Folders
  P65Foz9GpaSo6nnccJ9oHFL: 'vm-namiss',

  // PROD Album Folders
  PDdgYxDEKq4KMQLtB5aAgVs: 'bracken18',
};

export { ALBUM_FOLDER_UB_REDIRECTS };
